export const isStrategicPrintServices = (rank?: string) => {
  return rank?.includes('SPSP')
}
